import script from "./FreeProposal.vue?vue&type=script&lang=ts&setup=true"
export * from "./FreeProposal.vue?vue&type=script&lang=ts&setup=true"

import "./FreeProposal.vue?vue&type=style&index=0&id=1a0a2454&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a0a2454"]])

export default __exports__